// extracted by mini-css-extract-plugin
export default {"notes":"NotesBox_notes__zB5bV","notes-form":"NotesBox_notes-form__bU8FK"};